module.exports = __webpack_public_path__ + "static/media/img-card-top-front.1756a3fc.png";